// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__1OlVH","title":"style_title__3RZrp","imgBox":"style_imgBox__16-il","img":"style_img__vz6iH"};